"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_NOT_FOUND = exports.Permissions = exports.sanitizeCustomer = exports.DataItemTypeEnum = void 0;
const lodash_1 = require("lodash");
var DataItemTypeEnum;
(function (DataItemTypeEnum) {
    DataItemTypeEnum["TopUp"] = "top-up";
})(DataItemTypeEnum || (exports.DataItemTypeEnum = DataItemTypeEnum = {}));
const sanitizeCustomer = (customer) => {
    return (0, lodash_1.omit)(customer, ['vas']);
};
exports.sanitizeCustomer = sanitizeCustomer;
exports.Permissions = {
    Admin: 'ADMIN',
    CustomerAdmin: 'CUSTADMIN',
    Support: 'SUPPORT',
    Manufacturing: 'MANUFACTURING',
    Application: 'APPLICATION',
    EndCustomer: 'END_CUSTOMER',
    ClaimDevice: '__CLAIM_DEVICE',
    CellDevice: '__CELL_DEVICE',
    CellPlan: '__CELL_PLAN',
    EditDevice: '__EDIT_DEVICE',
    EditOrganization: '__EDIT_ORG',
    EditOrganizationPayment: '__EDIT_ORG_PAYMENT',
    EndUserAdmin: '__END_USER_ADMIN',
    OrganizationPurchase: '__ORG_PURCHASE',
    OrganizationRefund: '__ORG_REFUND',
    OrganizationBalance: '__ORG_BALANCE',
    Reporting: '__REPORTING',
    EditTax: '__EDIT_TAX',
    EndUserDeviceCreate: '__END_USER_DEVICE_CREATE',
    PlanPrePaid: '__PLAN_PRE_PAID',
    SourceEditCreditCard: '__SOURCE_EDIT_CREDIT_CARD',
    SourceEditAchDebit: '__SOURCE_EDIT_ACH_DEBIT',
    SourceAchDebitManualVerification: '__SOURCE_ACH_DEBIT_MANUAL_VERIFICATION',
    SourceEditBankTransfer: '__SOURCE_EDIT_BANK_TRANSFER'
};
exports.USER_NOT_FOUND = 'USER NOT FOUND';
//# sourceMappingURL=models.js.map